import type { ReactNode } from 'react'
import type { BrandMention } from '@/types/brandMentions'

export function mentionPreview(mention: BrandMention): string {
	return (mention.title || mention.text || '').replace(/\s+/g, ' ').trim()
}

export function formatCompactTime(
	value: string,
	t: (key: string) => string
): string {
	const diffMins = Math.floor((Date.now() - new Date(value).getTime()) / 60000)
	if (diffMins < 1) return t('brandMentions.timeNow')
	if (diffMins < 60) return t('brandMentions.timeMinutes', { count: diffMins })
	const diffHours = Math.floor(diffMins / 60)
	if (diffHours < 24) return t('brandMentions.timeHours', { count: diffHours })
	const diffDays = Math.floor(diffHours / 24)
	if (diffDays < 7) return t('brandMentions.timeDays', { count: diffDays })
	return t('brandMentions.timeWeeks', { count: Math.floor(diffDays / 7) })
}

export function formatMentionDate(value: string, locale: string) {
	return new Date(value).toLocaleString(locale === 'fr' ? 'fr-FR' : 'en-GB', {
		timeZone: 'Europe/Paris',
		dateStyle: 'medium',
		timeStyle: 'short',
	})
}

export function highlightBrand(text: string, brandName: string | null): ReactNode[] {
	if (!brandName) return [text]
	const pattern = new RegExp(
		`(${brandName.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')})`,
		'gi'
	)
	return text.split(pattern).map((part, index) =>
		part.toLowerCase() === brandName.toLowerCase() ? (
			<mark key={index} className="rounded bg-primary/15 px-0.5 text-foreground">
				{part}
			</mark>
		) : (
			part
		)
	)
}
